import React from 'react';
import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react';

interface Props {
  matchedCount: number;
  totalCount: number;
  targetTeamName: string;
  onGoBackToStep3: () => void;
  onCreateNewAthletes: () => void;
  onCancel: () => void;
}

/**
 * Banner giallo Step 5 wizard quando 0 atleti matchati (M6.2 B10 secondary).
 * 3 CTA: torna Step 3, crea N nuovi, annulla.
 */
export function ZeroMatchBanner({
  matchedCount,
  totalCount,
  targetTeamName,
  onGoBackToStep3,
  onCreateNewAthletes,
  onCancel,
}: Props) {
  return (
    <Box
      borderWidth={1}
      borderColor="yellow.400"
      borderRadius="md"
      bg="yellow.50"
      p={4}
      mb={3}
    >
      <VStack align="stretch" gap={3}>
        <Text fontWeight="semibold" color="yellow.900">
          Attenzione: {matchedCount} su {totalCount} atleti del file trovati
          nel roster {targetTeamName}
        </Text>
        <Text fontSize="sm" color="yellow.800">
          Con tutta probabilità questi sono atleti di un altro team. Cosa vuoi
          fare?
        </Text>
        <HStack gap={2} wrap="wrap">
          <Button size="sm" colorPalette="green" onClick={onGoBackToStep3}>
            Ho sbagliato team · torno allo Step 3
          </Button>
          <Button
            size="sm"
            colorPalette="yellow"
            variant="outline"
            onClick={onCreateNewAthletes}
          >
            Creo {totalCount} nuovi atleti in {targetTeamName}
          </Button>
          <Button size="sm" variant="ghost" onClick={onCancel}>
            Annulla import
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
}
